import React from 'react';

import EstimatedPrices from '../components/EstimatedPrices';
import IndepRecrutement from '../components/IndepRecrutement';
import PropertyAdverts from '../components/PropertyAdverts';
import SoldProperties from '../components/SoldProperties';

import { Separator } from 'hosman-material';
import { imop } from '../../../../../shared/assets/logos';

const DeadSale = ({ sale, valuation, setValuation }) => {
  return (
    <div className='flex flex-col justify-center gap-12' data-testid='DeadSale'>
      <EstimatedPrices sale={sale} valuation={valuation} setValuation={setValuation} />

      {!sale.in_zone &&
        <div className='my-8'>
          <div className='flex flex-col gap-3 text-center'>
            <p className='h2 text-ih-indigo'>Hosman n'est pas (encore) présent à <span className='text-ih-blue'>{sale.property.city} !</span></p>

            {sale.send_to_imop &&
              <div className='flex flex-col items-center gap-2'>
                <p>Hosman n'est malheureusement pas encore présent sur votre zone, mais notre partenaire IMOP avec qui nous partageons l'excellence de l'accompagnement se fera un plaisir de vous accompagner dans votre projet.</p>
                <p>Ils vont vous contacter de notre part pour en discuter.</p>
                <img src={imop} alt='logo_imop' className='w-80' />
              </div>
            }

            {!sale.send_to_imop && <p>Nous sommes désolés, mais nous n'avons pas encore d'expert local dans votre ville. Afin de ne pas vous laisser sans solution dans votre projet immobilier, il est possible que vous soyez contactés par un agent partenaire.</p>}
          </div>
        </div>
      }

      <SoldProperties sale={sale} />

      <Separator margins='my-6' />

      <div className='flex flex-col md:flex-row items-center justify-center gap-8'>
        <IndepRecrutement />
        <PropertyAdverts sale={sale} />
      </div>
    </div>
  );
}

export default DeadSale;
